import type { SVGProps } from "react";

type IconProps = SVGProps<SVGSVGElement>;

function base(props: IconProps) {
  return {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.7,
    strokeLinecap: "round" as const,
    strokeLinejoin: "round" as const,
    width: 22,
    height: 22,
    "aria-hidden": true as const,
    ...props,
  };
}

export function IconStats(props: IconProps) {
  return (
    <svg {...base(props)}>
      <path d="M4 19.5h16" />
      <path d="M7 16V10" />
      <path d="M12 16V6" />
      <path d="M17 16v-4" />
    </svg>
  );
}

export function IconDashboard(props: IconProps) {
  return (
    <svg {...base(props)}>
      <rect x="3.5" y="3.5" width="7" height="7" rx="1.6" />
      <rect x="13.5" y="3.5" width="7" height="7" rx="1.6" />
      <rect x="3.5" y="13.5" width="7" height="7" rx="1.6" />
      <rect x="13.5" y="13.5" width="7" height="7" rx="1.6" />
    </svg>
  );
}

export function IconConsole(props: IconProps) {
  return (
    <svg {...base(props)}>
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <path d="M7 10l3 2-3 2" />
      <path d="M13 14h4" />
    </svg>
  );
}

export function IconCall(props: IconProps) {
  return (
    <svg {...base(props)}>
      <path d="M8.2 3.8l2.2 2.2a1.4 1.4 0 010 2L9.2 9.2c.8 1.8 2.2 3.2 4 4l1.2-1.2a1.4 1.4 0 012 0l2.2 2.2a1.4 1.4 0 010 2l-1.3 1.3c-.7.7-1.8 1-2.8.7-3.2-.8-6.1-2.8-8.3-5S3.4 8.7 2.6 5.5c-.3-1 .0-2.1.7-2.8L4.6 1.4a1.4 1.4 0 012 0z" />
      <path d="M16 4v5M13.5 6.5h5" />
    </svg>
  );
}

export function IconHistory(props: IconProps) {
  return (
    <svg {...base(props)}>
      <circle cx="12" cy="13" r="7" />
      <path d="M12 10v3.2l2.2 1.3" />
      <path d="M8 4.5L5.5 7H10" />
    </svg>
  );
}

export function IconScripts(props: IconProps) {
  return (
    <svg {...base(props)}>
      <path d="M7 4.5h7.5L19 9v10.5a1.5 1.5 0 01-1.5 1.5h-10A1.5 1.5 0 016 19.5v-13A2 2 0 018 4.5z" />
      <path d="M14.5 4.5V9H19" />
      <path d="M9 13h6M9 16.5h4" />
    </svg>
  );
}

export function IconSip(props: IconProps) {
  return (
    <svg {...base(props)}>
      <path d="M12 19v-6" />
      <circle cx="12" cy="10" r="2.2" />
      <path d="M7.2 8.2a5.5 5.5 0 019.6 0" />
      <path d="M4.8 5.8a8.5 8.5 0 0114.4 0" />
      <path d="M8 19h8" />
    </svg>
  );
}

export function IconAdmin(props: IconProps) {
  return (
    <svg {...base(props)}>
      <path d="M12 3.5l7 3v5.2c0 4.2-2.8 7.4-7 8.8-4.2-1.4-7-4.6-7-8.8V6.5l7-3z" />
      <path d="M9.5 12.2l1.8 1.8 3.4-3.6" />
    </svg>
  );
}

export function IconSettings(props: IconProps) {
  return (
    <svg {...base(props)}>
      <circle cx="12" cy="12" r="3" />
      <path d="M12 3.5v2.2M12 18.3v2.2M4.8 6.6l1.6 1.6M17.6 15.8l1.6 1.6M3.5 12h2.2M18.3 12h2.2M4.8 17.4l1.6-1.6M17.6 8.2l1.6-1.6" />
    </svg>
  );
}

export function IconSearch(props: IconProps) {
  return (
    <svg {...base(props)} width={18} height={18}>
      <circle cx="11" cy="11" r="6.5" />
      <path d="M16 16l4 4" />
    </svg>
  );
}
